import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
// import Raven from 'raven-js'
import router from './router'
// import RavenVue from 'raven-js/plugins/vue'
import './registerServiceWorker'

// Raven
//   .config( process.env.VUE_APP_SENTRY )
//   .addPlugin( RavenVue, Vue )
//   .install()

Vue.config.productionTip = false

Vue.mixin({
  data: () => {
    return {
      get urlApi() {
        return 'https://cpa-postback-socket-fahri5567.c9users.io'
      }
    }
  }
})

import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSignInAlt,
  faSignOutAlt,
  faHeart,
  faCoffee,
  faUsersCog,
  faSyncAlt,
  faWindowMinimize,
  faWindowMaximize,
  faCalendarAlt,
  faIdCard,
  faCheck,
  faEdit,
  faTrashAlt,
  faAngleRight
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add( faSignInAlt )
library.add( faSignOutAlt )
library.add( faHeart )
library.add( faCoffee )
library.add( faUsersCog )
library.add( faSyncAlt )
library.add( faWindowMinimize )
library.add( faWindowMaximize )
library.add( faCalendarAlt )
library.add( faIdCard )
library.add( faCheck )
library.add( faEdit )
library.add( faTrashAlt )
library.add( faAngleRight )

Vue.component( 'font-awesome-icon', FontAwesomeIcon )

Vue.use( BootstrapVue );

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
